export default __webpack_public_path__ + "static/media/CFD334.40f05ecc.jpg";